/**
 * @description 加载组件
 * @params actionType 动作类型 show/hide
 */
import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';


// 创建容器
const getContainer = () => {
  let el = document.getElementById('aia-bx-tool-box');
  if (el === null) {
    el = document.createElement('div');
    document.body.append(el);
    el.id = 'aia-bx-tool-box';
  }
  return el;
};

function notice(args) {
  const root = createRoot(getContainer());
  root.render(<LoadBar {...args} />);
  // return ReactDOM.render(<LoadBar {...args} />, div);
}
function LoadBar(props) {
  const { actionType } = props;
  return (
    <div
      style={{ backgroundColor: "rgba(255, 255, 255, .35)" }}
      className={`aia-bx-fix-layer aia-bx-loader' ${
        actionType === "show" ? "" : "aia-bx-hide"
      }`}
    >
      <div className="aia-bx-center">
        <div style={{ margin: "0 auto" }} className="aia-bx-loading"></div>
        {/* <p className='aia-bx-loading-txt'>Loading, please wait</p> */}
      </div>
    </div>
  );
}
let loadApi = {};

["show", "hide"].forEach((actionType) => {
  loadApi[actionType] = () => {
    return notice({ actionType });
  };
});

export default loadApi;
